import { render } from "./ListFormateur.vue?vue&type=template&id=1a18dea2&scoped=true"
import script from "./ListFormateur.vue?vue&type=script&lang=js"
export * from "./ListFormateur.vue?vue&type=script&lang=js"

import "./ListFormateur.vue?vue&type=style&index=0&id=1a18dea2&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a18dea2"]])

export default __exports__